// @flow
import React from 'react';
import type { EventPreviewType } from 'types/Event';
import Label from '../fragments/text/Label';
import { getMonthName, formatHours } from 'utils/dateUtils';
import { dynamicClassName } from 'utils/dynamicClassName';
import { Link } from 'react-router-dom';

type Props = {
  event: EventPreviewType,
  sidebar?: boolean
};

function getLink(event: EventPreviewType) {
  const { title } = event;

  if (event.redirection) {
    return (
      <a
        href={event.redirection}
        target="_blank"
        title={`Voir le détail de l'événement ${title}`}
        rel="noopener noreferrer"
        role="button"
        tabIndex={0}
      >
        {event.title}
      </a>
    );
  }

  return (
    <Link
      to={{
        pathname: `/evenements/${event.slug}`
      }}
      role="button"
      tabIndex={0}
      title={`Voir les détails de l'événement ${title}`}
    >
      {title}
    </Link>
  );
}

const TopEvent = (props: Props) => {
  let { label, categories } = props.event;
  if (categories && categories.length > 0) {
    label = categories.reduce((acc, category) => acc + (acc ? ' - ' : '') + category.name, '');
  }

  const { sidebar } = props;
  const startDate = props.event.startDate instanceof Date ? props.event.startDate : new Date(props.event.startDate);
  const endDate = props.event.endDate instanceof Date ? props.event.endDate : new Date(props.event.endDate);
  const classNamesCardContainer = dynamicClassName('event-top ');
  sidebar && classNamesCardContainer.add('box mb-4 mb-md-5');
  return (
    <div className={classNamesCardContainer.build()} data-day={startDate.getDate()}>
      <p className="event__date">
        <span className="event__day ft-h1">{startDate.getDate()}</span>
        <br />
        <span className="event__month ft-h6 ft-up">{getMonthName(startDate.getMonth())} — </span>
        <span className="event__info ft-h6">
          {formatHours(startDate)}
          {startDate.getTime() !== endDate.getTime() &&
            ` -
        ${formatHours(endDate)}`}
        </span>
      </p>
      <div className="event__content">
        <p className="event__title ft-h4">{getLink(props.event)}</p>
      </div>
      <Label label={label} />
    </div>
  );
};

export default TopEvent;
